import React from 'react';
import {MasterLayout} from 'layout';
import {TongHopKetQua} from 'modules/thong-ke-bao-cao';

class TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <TongHopKetQua type='THUC_HIEN_KET_LUAN_THANH_TRA_HANH_CHINH'/>
      </MasterLayout>
    );
  }
}

export default TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage;


// WEBPACK FOOTER //
// ./src/components/pages/thong-ke-bao-cao/TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage.jsx